import { useEffect, useContext } from 'react';
import { Col, Row, Grid, Skeleton } from 'antd';
import { useBenefitUsage } from 'all-in-one-shared-api';
import BenefitContext from 'pages/benefits/contexts/BenefitContext';

import { getCurrentPolicy, getRelationshipValue } from 'pages/benefits/utils/utils';

import UsageGroup from 'pages/benefits/sections/outpatients/components/UsageGroup';
import { SWR_KEY } from 'pages/benefits/types/benefitTypes';
import { useKeycloakReady } from 'hooks/useKeycloakReady';

const { useBreakpoint } = Grid;

function Usage() {
  const { md } = useBreakpoint();
  const { token } = useKeycloakReady();

  const { selectedFilterName, selectedFilterPeriod, policyInfoData } = useContext(BenefitContext);
  const currentPolicy = getCurrentPolicy(policyInfoData, selectedFilterName, selectedFilterPeriod);

  const memberType = currentPolicy?.memberType ?? '';
  const renewalNumber = currentPolicy?.renewalNumber ?? -1;

  const familyRelation = getRelationshipValue(currentPolicy?.familyRelationship || '');

  const {
    shouldFetch: usageShouldFetch,
    data: usageData,
    isLoading: isBenefitUsageLoading,
  } = useBenefitUsage(
    { name: SWR_KEY.BENEFIT_USAGE, params: { memberType, familyRelation, renewalNumber } },
    token ?? '',
    parseInt(memberType),
    familyRelation,
    'OP',
    renewalNumber,
  );

  useEffect(() => {
    usageShouldFetch(!!policyInfoData && Boolean(memberType) && Boolean(familyRelation) && renewalNumber !== -1);
  }, [usageShouldFetch, policyInfoData, memberType, familyRelation, renewalNumber]);

  const benefitGroupUsages = usageData && usageData.benefitGroupUsages;

  if (isBenefitUsageLoading) return <Skeleton active={isBenefitUsageLoading} />;

  if (benefitGroupUsages) {
    return (
      <Row justify="start" gutter={[{ md: 24 }, 24]}>
        {benefitGroupUsages.map((usage) => (
          <Col key={usage.groupTitle || 'general-group'} span={md ? 12 : 24}>
            <UsageGroup benefitGroupUsages={usage} />
          </Col>
        ))}
      </Row>
    );
  }

  return <></>;
}

export default Usage;
